export { RatePlanLegalText } from './RatePlanLegalText';
export { RatePlanVasLegalText } from './RatePlanVasLegalText';
export { GiftLegalText } from './GiftLegalText';
